import FamilyTypeOptionsModal from 'app/components/Hotels/FamilyTypeOptionsModal';
import { ItemType, roomTypes } from 'app/modules/Constants';
import Helper from 'app/modules/Helper';
import { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { openInput } from '../../../actions/baseActions';
import { setRoomType, updateRooms } from '../../../actions/hotelActions';
import { emitGuestsClickGAEvent, emitGuestsSelectGAEvent } from '../../../utils/ga-event-helpers';
import BasicDropDown from '../Common/BasicDropDown';

interface IRoom {
	adults: number;
	children: number;
}

type RoomsProps = {
	selectedRoomType: ItemType;
	name: string;
	openedInput?: string;
	rooms: IRoom[];
	lng: string;
	roomsPortalRef: RefObject<HTMLDivElement>;
	postfix?: string;
	setRoomType: (type: ItemType) => void;
	openInput: (name: string | null) => void;
	updateRooms: (rooms: IRoom[]) => void;
};

enum VALUES {
	ONE_PERSON = 'one-person',
	TWO_PERSON = 'two-person',
	FAMILY = 'family',
}

const Rooms: FC<RoomsProps> = (props) => {
	const { setRoomType, updateRooms, openInput, selectedRoomType, name, roomsPortalRef, postfix, lng } = props;
	const { t } = useTranslation();
	const isRtl = Helper.isRtlLanguage(lng);

	const onSelect = (item: ItemType) => {
		setRoomType(item);

		if (item.value === VALUES.ONE_PERSON) {
			updateRooms([{ adults: 1, children: 0 }]);
			emitGuestsSelectGAEvent('hotels', { rooms: 1, adults: 1, children: 0, total: 1 });
		}

		if (item.value === VALUES.TWO_PERSON) {
			updateRooms([{ adults: 2, children: 0 }]);
			emitGuestsSelectGAEvent('hotels', { rooms: 1, adults: 2, children: 0, total: 2 });
		}

		if (item.value === VALUES.FAMILY) {
			openInput(`family-type-options${postfix}`);
		} else {
			openInput(null);
		}
	};
	const getCustomSelectedTextForFamily = () => {
		const rooms = props.rooms;
		let guests = 0;
		for (let i = 0; i < rooms.length; i++) {
			guests += rooms[i].adults + rooms[i].children;
		}
		let roomsName = t('keywords.rooms');
		const guestsName = t('keywords.guests');
		if (rooms.length === 1) {
			roomsName = t('keywords.room');
		}
		if (isRtl) {
			const guestText = guests === 1 ? ` ${guestsName} ${guests} ` : ` ${guests} ${guestsName} `;
			const roomsText = rooms.length === 1 ? ` ${roomsName} ${rooms.length}` : ` ${rooms.length} ${roomsName}`;
			return `${roomsText} , ${guestText}`;
		}
		return `${rooms.length} ${roomsName}, ${guests} ${guestsName}`;
	};

	const onGuestsClick = () => {
		// Mirror the D3 travelers_click open-guard: emit hotel_guest_click only on the
		// closed->open transition of the room-type dropdown, not on bubbled clicks (A3).
		if (props.openedInput !== name) {
			emitGuestsClickGAEvent('hotels');
		}
	};

	return (
		<div id="rooms">
			<BasicDropDown
				icon={selectedRoomType.icon}
				mainInput
				showOnSmallDevices
				showCustomSelectedText={selectedRoomType.value === 'family'}
				customSelectedText={getCustomSelectedTextForFamily()}
				onClick={onGuestsClick}
				onSelect={onSelect}
				name={name}
				selected={selectedRoomType}
				placeholder={t('keywords.rooms')}
				preventCloseInput
				items={roomTypes}
			/>
			<div style={{ position: 'relative' }}>
				<FamilyTypeOptionsModal openedInput={props.openedInput} portalRef={roomsPortalRef} postfix={postfix} />
			</div>
		</div>
	);
};
// @ts-ignore
const mapStateToProps = (state) => ({
	selectedRoomType: state.hotel.selectedRoomType,
	openedInput: state.base.openedInput,
	rooms: state.hotel.rooms,
	random: state.hotel.random,
});
export default connect(mapStateToProps, { setRoomType, updateRooms, openInput })(Rooms);
